import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrganizationService } from '@/organization/organization/organization.service';
import { InfoboxService } from '@/common/infobox/infobox.service';
import { Currency } from '@/reservation/reservation.model';
import {
	BankAccountUpdatePayload,
	OrganizationBankAccountDialogData,
	OrganizationBankAccountMode,
} from '@/organization/organization/organization-bank-accounts/organization-bank-accounts.model';

const POLISH_KIND_ID = 1;

@Component({
	selector: 'app-organization-bank-accounts-add-edit',
	templateUrl: './organization-bank-accounts-add-edit.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationBankAccountsAddEditComponent implements OnInit {
	mode: OrganizationBankAccountMode;
	bankAccountData: BankAccountUpdatePayload = {
		id: null,
		kind: null,
		currency: null,
		isActive: false,
		number: null,
		swift: null,
		organization: null,
		user: null,
		mainAccount: false,
		fastAlior: false,
		shortName: null,
	};
	doesMainAccountExist = false;
	accountKind = [];
	currencies = [];
	protected readonly OrganizationBankAccountMode = OrganizationBankAccountMode;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		private readonly data: OrganizationBankAccountDialogData,
		private readonly organizationService: OrganizationService,
		private readonly infobox: InfoboxService,
		private readonly dialogRef: MatDialogRef<OrganizationBankAccountsAddEditComponent>,
	) {}

	ngOnInit(): void {
		this.accountKind = this.organizationService.enterpriseData.accountKind;
		this.currencies = this.organizationService.enterpriseData.currency;

		if (!this.bankAccountData.kind) {
			this.bankAccountData.kind = this.accountKind.find((kind) => kind.id === POLISH_KIND_ID)?.id ?? null;
		}

		if (this.data) {
			this.mode = this.data.mode ?? OrganizationBankAccountMode.ADD;
			if (this.mode === OrganizationBankAccountMode.EDIT) {
				this.bankAccountData = this.data.bankAccount;
			}
		}

		this.doesMainAccountExist =
			!!(
				this.organizationService.enterpriseData.mainAccount &&
				this.organizationService.enterpriseData.mainAccount.length
			) && this.bankAccountData.id !== this.organizationService.enterpriseData.mainAccount[0]?.id;
	}

	bankAccountSave(mode: OrganizationBankAccountMode): void {
		if (
			this.bankAccountData.number === null ||
			this.bankAccountData.currency === null ||
			this.bankAccountData.kind === null
		) {
			this.infobox.error('Wymagane pola nie mogą być puste!');
			return;
		}

		const dialogData: OrganizationBankAccountDialogData = {
			mode: mode,
			bankAccount: {
				...this.bankAccountData,
				currency:
					typeof this.bankAccountData.currency === 'object'
						? this.bankAccountData.currency.id
						: this.bankAccountData.currency,
			},
		};
		this.dialogRef.close(dialogData);
	}

	organizationContactComparison(option: Currency, value: Currency): boolean {
		return option.id === value.id;
	}
}
